// extracted by mini-css-extract-plugin
export var input = "ContactForm-module--input--GDJE2";
export var input__area = "ContactForm-module--input__area--yn3xh";
export var req = "ContactForm-module--req--9-77m";
export var button = "ContactForm-module--button--83UcP";